///////////////////////////////////
// User
///////////////////////////////////

import moment, { Moment } from 'moment'

export type ConfigurationData = {
  isMaintenanceMode: boolean
  maintenanceMode?: {
    startAt: string
    endAt: string
    message: string
  }
}

export default class Configuration {
  isMaintenanceMode: boolean = false

  maintenanceMode?: {
    startAt: Moment
    endAt: Moment
    message: string
  }

  // Constructor --------------------------------------------------------------

  constructor(params?: ConfigurationData) {
    if (!params) return

    Object.assign(this, params)

    if (params.maintenanceMode)
      this.maintenanceMode = {
        ...params.maintenanceMode,
        startAt: moment(params.maintenanceMode.startAt),
        endAt: moment(params.maintenanceMode.endAt),
      }
  }
}
